import React from "react";
import { withRouter } from "react-router-dom";

import { getQueryParams } from "@/utils/filters";
import { Policy } from "@/components/Policy/Policy";
import { PRIVACY } from "@/core/constants";

const PrivacyPolicyPage = (props) => {
  const version = getQueryParams("version", props.location.search);

  return <Policy policyType={PRIVACY} version={version} />;
};

export default withRouter(PrivacyPolicyPage);
